import { Part } from "../Types/part";
import { PartsFilterState } from "../components/PartsFilters";

export function applyPartFilters(
  parts: Part[],
  filters: PartsFilterState,
): Part[] {
  return parts.filter((part) => {
    // OEM
    if (filters.oem === "oem" && !part.oem) return false;
    if (filters.oem === "aftermarket" && part.oem) return false;

    // Price
    if (filters.minPrice !== undefined && part.price < filters.minPrice)
      return false;
    if (filters.maxPrice !== undefined && part.price > filters.maxPrice)
      return false;

    // Stock
    if (filters.inStockOnly && part.stock <= 0) return false;

    // Title
    if (
      filters.title &&
      !part.title.toLowerCase().includes(filters.title.toLowerCase())
    )
      return false;

    // Part number
    if (
      filters.partNumber &&
      !part.partNumber.toLowerCase().includes(filters.partNumber.toLowerCase())
    )
      return false;

    return true;
  });
}
